<div class="tr layout-column">
  <div class="layout-row layout-align-start-center">
    <!--Agent-->
    <div class="td medium layout-row layout-align-start-center flex-15 text-ellipsis">

      <app-user-avatar [user]="agentRouteScore.agentReference"
                       [url]="agentRouteScore.agentReference.avatarUrl"
                       size="xsmall"
                       class="margin-right-5">
      </app-user-avatar>

      <div class="layout-column">

        <div class="layout-row layout-align-start-center">
          <app-agent-itinerary-link [linkToAgentView]="true"
                                    [agentName]="agentRouteScore.agentReference.firstName + ' ' + agentRouteScore.agentReference.lastName"
                                    [agentId]="agentRouteScore.agentId"
                                    [isShowCopyButton]="true">
          </app-agent-itinerary-link>

          <!--          <bringoz-icon class="margin-left-5 secondary-100"-->
          <!--                        *ngIf="agentRouteScore.agentBranchReferences?.length"-->
          <!--                        iconName="branch" classSize="md"-->
          <!--                        [ngbTooltip]="tooltipTmpl" placement="top" openDelay="300"-->
          <!--                        triggers="hover">-->
          <!--            -->
          <!--          </bringoz-icon>-->
          <!--          <ng-template #tooltipTmpl>-->
          <!--            <div class="layout-column">-->
          <!--              <span *ngFor="let branch of agentRouteScore.agentBranchReferences">-->
          <!--                {{branch.name}}-->
          <!--              </span>-->
          <!--            </div>-->
          <!--          </ng-template>-->

          <!--          <app-agent-location class="margin-left-5"-->
          <!--                              *ngIf="agentRouteScore.agentLastKnownLocation.deviceReference"-->
          <!--                              [location]="agentRouteScore.agentLastKnownLocation.coordinates"-->
          <!--                              direction="right"-->
          <!--                              [showText]="false"-->
          <!--                              [locationTrackingApproval]="agentRouteScore?.agentLocationTrackingApproval"-->
          <!--                              [gpsStatus]="agentRouteScore.agentLastKnownLocation.deviceReference?.gpsStatus"-->
          <!--                              [gpsPermission]="agentRouteScore.agentLastKnownLocation.deviceReference?.gpsPermission"-->
          <!--                              [lastUpdate]="agentRouteScore.agentLastKnownLocation.updatedAt">-->
          <!--          </app-agent-location>-->
        </div>

        <!--        <div class="layout-row layout-align-start-center">-->
        <!--          <app-bringoz-tags *ngIf="agentRouteScore.agentReference.tags"-->
        <!--                            [tags]="agentRouteScore.agentReference.tags"-->
        <!--                            backgroundColor="transparent"-->
        <!--                            color="#7E7E7E"-->
        <!--                            class="margin-right-5"-->
        <!--                            maxTags="1">-->
        <!--          </app-bringoz-tags>-->

        <!--          <span *ngIf="agentRouteScore.agentReference.externalId"-->
        <!--                class="br-body-1 text-ellipsis font-weight-400 gray-102">-->
        <!--            {{agentRouteScore.agentReference.externalId}}-->
        <!--          </span>-->

        <!--        </div>-->
      </div>

    </div>

    <!--Missed Tasks-->
    <div class="td xsmall layout-row flex-10 text-ellipsis">
      <span class="br-body-1 font-weight-400 primary-100">{{agentRouteScore.missedTasks}}</span>
    </div>

    <!--Hours-->
    <div class="td xsmall layout-row flex-10 text-ellipsis">
      <span class="br-body-1 font-weight-400 primary-100">{{agentRouteScore.workingTime | bringozTimeConvert }}</span>
    </div>

    <!--Start Time-->
    <div class="td xsmall layout-row flex-15 text-ellipsis"
         [class.performance-metric]="agentRouteScore.startsOnScore >= 0"
         [class.good-score]="agentRouteScore.startsOnScore >= 80"
         [class.average-score]="agentRouteScore.startsOnScore > 60 && agentRouteScore.startsOnScore < 80"
         [class.bad-score]="agentRouteScore.startsOnScore <= 60">

    <span *ngIf="agentRouteScore.startsOnScore >= 0"
          class="br-body-1 font-weight-600">{{agentRouteScore.startsOnScore}} %</span>
    </div>

    <!--End Time-->
    <div class="td xsmall layout-row flex-15 text-ellipsis"
         [class.performance-metric]="agentRouteScore.endsOnScore >= 0"
         [class.good-score]="agentRouteScore.endsOnScore >= 80"
         [class.average-score]="agentRouteScore.endsOnScore > 60 && agentRouteScore.endsOnScore < 80"
         [class.bad-score]="agentRouteScore.endsOnScore <= 60">

        <span *ngIf="agentRouteScore.endsOnScore >= 0"
              class="br-body-1 font-weight-600">{{agentRouteScore.endsOnScore}} %</span>
    </div>

    <!--Sequence-->
    <div class="td large layout-row layout-align-start-center flex"
         [class.performance-metric]="agentRouteScore.sequenceScore >= 0"
         [class.good-score]="agentRouteScore.sequenceScore >= 80"
         [class.average-score]="agentRouteScore.sequenceScore > 60 && agentRouteScore.sequenceScore < 80"
         [class.bad-score]="agentRouteScore.sequenceScore <= 60">
       <span *ngIf="agentRouteScore.sequenceScore >= 0"
             class="br-body-1 font-weight-600">{{agentRouteScore.sequenceScore}} %</span>
    </div>

    <!--Route Score-->
    <div
      class="td xsmall layout-row layout-align-start-center flex-5 text-ellipsis full-height padding-left-0 padding-right-0"
      [ngbTooltip]="scoreTooltip" openDelay="300" triggers="hover">
      <app-bringoz-donut-chart [segments]="routeScorePieChartData.segments"
                               [pieChartConfiguration]="{
                                    width: isBigScreen ? 3.6 : 4.6,
                                    height: isBigScreen ?  2.6 : 3.6,
                                    fontSize:12
                                }"
                               [innerTextConfiguration]="routeScorePieChartData.innerTextConfiguration">
      </app-bringoz-donut-chart>

      <ng-template #scoreTooltip>
        <div class="layout-column">
          <div *ngIf="agentRouteScore.startsOnScore >=0" class="layout-row layout-align-start-center">
            <span class="primary-100 br-body-2 font-weight-400" translate>Start time scoring</span>
            <span class="br-body-1 font-weight-600 margin-left-10"
                  [class.good-score]="agentRouteScore.startsOnScore >= 80"
                  [class.average-score]="agentRouteScore.startsOnScore > 60 && agentRouteScore.startsOnScore < 80"
                  [class.bad-score]="agentRouteScore.startsOnScore <= 60">
                      {{agentRouteScore.startsOnScore}} %
            </span>
          </div>
          <div *ngIf="agentRouteScore.endsOnScore >=0" class="layout-row layout-align-start-center">
            <span class="primary-100 br-body-2 font-weight-400" translate>End time scoring</span>
            <span class="br-body-1 font-weight-600 margin-left-10"
                  [class.good-score]="agentRouteScore.endsOnScore >= 80"
                  [class.average-score]="agentRouteScore.endsOnScore > 60 && agentRouteScore.endsOnScore < 80"
                  [class.bad-score]="agentRouteScore.endsOnScore <= 60">
                      {{agentRouteScore.endsOnScore}} %
                    </span>
          </div>
          <div *ngIf="agentRouteScore.sequenceScore >=0"
               class="layout-row layout-align-start-center">
            <span class="primary-100 br-body-2 font-weight-400" translate>Correct sequence</span>
            <span class="br-body-1 font-weight-600 margin-left-10"
                  [class.good-score]="agentRouteScore.sequenceScore >= 80"
                  [class.average-score]="agentRouteScore.sequenceScore > 60 && agentRouteScore.sequenceScore < 80"
                  [class.bad-score]="agentRouteScore.sequenceScore <= 60">
                      {{agentRouteScore.sequenceScore}} %
                    </span>
          </div>
          <hr class="margin-top-10 margin-bottom-10">

          <div *ngIf="agentRouteScore.totalScore >=0" class="layout-row layout-align-start-center">
            <span class="primary-100 br-body-2 font-weight-400" translate>Average score</span>
            <span class="br-body-1 font-weight-600 margin-left-10"
                  [class.good-score]="agentRouteScore.totalScore >= 80"
                  [class.average-score]="agentRouteScore.totalScore > 60 && agentRouteScore.totalScore < 80"
                  [class.bad-score]="agentRouteScore.totalScore <= 60">
                      {{agentRouteScore.totalScore}} %
                    </span>
          </div>
        </div>
      </ng-template>
    </div>

    <div *ngIf="onAllowExpand" class="td xxxsmall flex-5">
      <bringoz-button type="tertiary"
                      (onClick)="onToggleExpand.emit(agentRouteScore.agentId)">

        <bringoz-icon [iconName]="!!expandedData ? 'chevron-up' : 'chevron-down'" class="secondary-100"></bringoz-icon>

      </bringoz-button>

    </div>
  </div>

  <ng-container *ngIf="!!expandedData">
    <app-agent-routes-performance-row *ngFor="let route of expandedData" [route]="route"
                                      isAllowViewRouteTasks="true"
                                      (viewTasksEvent)="onViewAgentRouteTasks($event.tasks, $event.routeName, $event.plannedTasksOrder, $event.actualTasksOrder)"
                                      class="expand-row">

    </app-agent-routes-performance-row>
  </ng-container>
</div>
